import VideoCategoryList from "../components/VideoCategoryList";

const ListVideoCategoryPage = () => {
  return (
    <VideoCategoryList />
  );
};

export default ListVideoCategoryPage;
